<template>
  <el-row class="articleContent">
    <el-col :span="24">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >公共服务</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >信息查询服务</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ regulations.laws }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="grid-content bg-purple-dark">
        <p class="tlt1">{{ regulations.laws }}</p>
        <p class="tlt3">
          浏览次数：<span>{{ regulations.num }}</span>
        </p>
        <p class="tlt2">（数据来源：国务院政府网站）</p>
        <div class="hxl_title"></div>
      </div>
      <div class="announcement">
        <div class="ipt">
          <el-input
            v-model="searchOn"
            maxlength="24rem"
            placeholder="请输入名称/时代/地址"
            class="input-with-select"
          >
            <el-button
              class="searchFor"
              slot="append"
              size="small"
              @click="seeSer()"
              >搜索</el-button
            >
          </el-input>
          <el-button size="small" class="reset" @click="resetOn()"
            >重置</el-button
          >
        </div>
        <div class="dat">
          <div class="paging">
            <el-select
              v-model="nature"
              clearable
              placeholder="批次"
              class="nature"
              @change="natureChange()"
            >
              <el-option
                v-for="item in natureList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="culturalRelic"
              clearable
              placeholder="文物类型"
              class="culturalRelic"
              @change="culturalRelicChange()"
            >
              <el-option
                v-for="item in culturalRelicList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="publish"
              clearable
              placeholder="公布类型"
              class="publish"
              @change="publishChange()"
            >
              <el-option
                v-for="item in publishList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <el-button
              size="small"
              icon="el-icon-refresh"
              class="refresh"
              @click="refresh()"
              >刷新</el-button
            >
          </div>
        </div>
        <div style="padding: 0 20px; text-align: center">
          <el-table
            :data="legalForms"
            :stripe="true"
            border
            fit
            style="width: 100%"
            :header-cell-style="{
              background: '#ebe6db',
              color: '#585856',
              borderColor: '#585856',
            }"
            :cell-style="{ borderColor: '#585856' }"
          >
            <el-table-column
              align="center"
              prop="batchNumName"
              label="批次"
              min-width="110px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="serialNum"
              label="编号"
              min-width="60px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="classNum"
              label="分类号"
              min-width="70px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="name"
              label="名称"
              min-width="200px"
            >
            </el-table-column>

            <el-table-column
              align="center"
              prop="ncrpuScTypeName"
              label="文物类型"
              min-width="108px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="age"
              label="时代"
              min-width="108px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="address"
              label="地址"
              min-width="108px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="publishWayName"
              label="公布类型"
              min-width="108px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="remarks"
              label="备注"
              min-width="152px"
            >
            </el-table-column>
          </el-table>
          <el-pagination
            popper-class="pageclass"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 40, 80]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import {
  URL_CULTURAL_RELICS_PROTECTION,
  URL_COMPREHENSIVE_EXCUSE,
  URL_DESCRIPTION_FIND,
} from "../../../utils/api";
import util from "../../../utils/util";
import { frontHeater } from "../../../utils/md5encryption";
export default {
  inject: ["reload"],
  props: [],
  components: {},
  data() {
    return {
      // 基本数据
      regulations: {
        //  标题+面包屑
        laws: "",
        // 浏览次数
        num: "2",
      },
      //   批次
      natureList: [],
      //批次
      nature: null,
      //  文物类型
      culturalRelicList: [],
      //文物类型
      culturalRelic: null,
      // 公布类型
      publishList: [],
      // 公布类型
      publish: null,
      //   搜索
      searchOn: null,
      // 表格
      legalForms: [],
      // 前往页数
      currentPage: 1,
      // 总条数
      total: 0,
      pagesize: 20,
    };
  },
  computed: {},
  methods: {
    // 获取列表数据
    getList() {
      let result = frontHeater(
        ["batchNum", "ncrpuScTypeCode", "publishWayCode"],
        [this.nature, this.culturalRelic, this.publish]
      );
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        pageNumber: this.currentPage,
        pageSize: this.pagesize,
        keyWord: this.searchOn,
        batchNum: this.nature,
        ncrpuScTypeCode: this.culturalRelic,
        publishWayCode: this.publish,
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["batchNum"] = this.nature;
      // this.$http.defaults.headers.common["ncrpuScTypeCode"] =
      //   this.culturalRelic;
      // this.$http.defaults.headers.common["publishWayCode"] = this.publish;
      this.$http
        .post(Url + URL_CULTURAL_RELICS_PROTECTION, params)
        .then((resp) => {
          if (resp.status === 200) {
            this.legalForms = resp.data.data;
            this.total = resp.data.recordsTotal;
          }
        });
    },
    // 获取批次
    getBatchList() {
      let result = frontHeater(["ClassCode"], ["BatchNum"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        ClassCode: "BatchNum",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] = "BatchNum";
      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          this.natureList = res.data.data;
        }
      });
    },
    // 获取文物类型
    getCulturalType() {
      let result = frontHeater(["ClassCode"], ["NcrpuScTypeAll"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        ClassCode: "NcrpuScTypeAll",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] = "NcrpuScTypeAll";
      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          this.culturalRelicList = res.data.data;
        }
      });
    },
    // 获取公布类型
    getPublicationType() {
      let result = frontHeater(["ClassCode"], ["PublishWay"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        ClassCode: "PublishWay",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] = "PublishWay";
      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          this.publishList = res.data.data;
        }
      });
    },
    // 获取浏览次数
    getNumberViews() {
      let result = frontHeater(["dataType"], ["DataNcrpuSc"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        dataType: "DataNcrpuSc",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["dataType"] = "DataNcrpuSc";
      this.$http.post(Url + URL_DESCRIPTION_FIND, params).then((res) => {
        if (res.status === 200) {
          this.regulations.num = res.data.data.viewTimes;
        }
      });
    },
    // 搜索
    seeSer() {
      this.getList();
    },
    // 重置
    resetOn() {
      this.searchOn = null;
      this.nature = null;
      this.publish = null;
      this.culturalRelic = null;
      this.currentPage = 1;
      this.pagesize = 20;
      this.getList();
    },
    // 刷新
    refresh() {
      this.resetOn();
    },
    // 解决换页后index从1开始
    count(index) {
      return (this.currentPage - 1) * this.pagesize + index + 1;
    },
    // 确定页数
    handleSizeChange(val) {
      this.pagesize = val;
      this.getList();
    },
    // 当前页数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    culturalRelicChange() {
      this.getList();
    },
    natureChange() {
      this.getList();
    },
    publishChange() {
      this.getList();
    },
  },
  mounted() {
    this.regulations.laws = this.$route.query.title;
    this.getList();
    this.getBatchList();
    this.getCulturalType();
    this.getPublicationType();
    this.getNumberViews();
  },
};
</script>
<style scoped lang='less'>
@import "../../../styles/theme";
@import "../../../styles/comSty";
@import "../../../styles/Hierarchy";
.tlt1 {
  font-size: 18px;
  font-weight: 700;
  color: #b71c1c;
  margin: 10px 0;
  text-align: center;
}
.tlt2 {
  margin: 0;
  text-align: center;
  font-size: 16px;
}
.tlt3 {
  margin: 0 auto;
  padding-right: 40px;
  text-align: right;
  font-size: 16px;
  color: #444;
  font-weight: 700;
  span {
    color: @theme-color;
  }
}
.hxl_title {
  font-size: 22px;
  padding-bottom: 10px;
  color: #b71c1c;
  border-bottom: 3px solid #b71c1c;
}
.nature {
  width: 150px;
}
.culturalRelic {
  width: 300px;
}
.publish {
  width: 208px;
}
.dat {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  margin: 10px 0;
  align-items: center;
}
</style>